<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ financialInstitutionName }}</span>
		<app-button
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
		>
			{{
				mortgageeType === mortgageTypes.INSTITUTION
					? 'Create new branch'
					: 'Create new lender'
			}}
		</app-button>
	</div>
</ng-template>

<ng-template #institutionTemplate let-item>
	<div class="flex flex-col">
		<div>
			<ng-container *ngIf="mortgageeType !== mortgageTypes.COMPUTERSHARE">
				<span>{{ item.transitNumber }}</span>
			</ng-container>
			<div>{{ item?.name }}</div>
		</div>

		<span
			*ngIf="mortgageeType !== mortgageTypes.COMPUTERSHARE"
			class="whitespace-nowrap text-sm"
		>
			{{ item?.branchAddress?.street }}, {{ item?.branchAddress?.city }}
		</span>
	</div>
</ng-template>

<div class="flex items-center mt-2 w-full">
	<ui-button
		*ngIf="!autoComplete && !showDischargeFields"
		size="sm"
		icon="plus"
		class="ml-5"
		(click)="addBranch()"
		label="Add Branch"
	></ui-button>

	<div class="w-full" *ngIf="autoComplete">
		<app-auto-complete
			(onSelect)="onSelect($event)"
			[placeholder]="
				mortgageeType === mortgageTypes.INSTITUTION
					? 'Search to add a branch'
					: 'Search to add a lender'
			"
			[itemGroups]="[
				{
					items: [{ value: 'createNew' }],
					template: createNewTemplate,
					type: dropdownSelect.CREATEINSTITUTION,
				},
				{
					items: financialInstitutionsBranches,
					template: institutionTemplate,
					noResultsMessage: noResultsMessage,
					type: dropdownSelect.SELECTINSTITUTION,
				},
			]"
			[(ngModel)]="financialInstitutionName"
			name="dual-dropdown-1"
			(debounce)="search($event)"
			[loading]="loading"
			width="w-full"
		>
		</app-auto-complete>
	</div>
</div>
